package com.gastoncantera.intercom

import kotlinx.browser.document

actual fun appVersionName(): String =
    document.querySelector("meta[name='app-version']")
        ?.getAttribute("content")
        ?.trim()
        .orEmpty()
